import { IGetOrdemCompraBancoDropDownUseCase } from "../../../presentation/useCases/read/get_ordem_compra_banco_drop_down_use_case";
import { OrdemCompraBancoDropDown } from "../../models/ordem_compra_banco_dropdown";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetOrdemCompraBancoDropDownUseCase
 */

export class GetOrdemCompraBancoDropDownUseCase implements IGetOrdemCompraBancoDropDownUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getOrdemCompraBancoDropDown(
    idOrdemCompra: number | undefined,
  ): Promise<OrdemCompraBancoDropDown[]> {
    if (idOrdemCompra === undefined) throw new Error('Falha ao obter id de ordem de compra!');
    return await this.repository.getOrdemCompraBancoDropDown(
      idOrdemCompra,
    );
  }
}
